import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import {
  mapToServiceRequest,
  mapToServiceRequestWithTimeoff
} from '~/modules/resourcing/common/util';
import { ResourceRequestStatus } from '~/types';
import { getCompleteResourceRequestQueries } from './withMarkResourceRequestAsComplete';

const useMarkResourceRequestAsComplete = ({
  resourceRequest,
  showTimeOff,
  chartDateRange,
  showHolidays,
  additionalRequestParams,
  cacheUpdateFunctions
}) => {
  const {
    mutationDocument,
    mutationWithTimeoffDocument
  } = getCompleteResourceRequestQueries();

  const [
    markResourceRequestAsComplete,
    { error: markAsCompleteError }
  ] = useMutation(mutationDocument);

  const [
    markResourceRequestAsCompleteWithTimeoff,
    { error: markAsCompleteWithTimeoffError }
  ] = useMutation(mutationWithTimeoffDocument);

  const requestParams = {
    request: resourceRequest,
    responseType: 'markResourceRequestAsComplete2',
    responseTypeName: 'MarkResourceRequestAsCompleteResult',
    requestStatus: ResourceRequestStatus.Complete,
    ...additionalRequestParams
  };

  const onMarkResourceRequestAsComplete = useCallback(() => {
    if (!showTimeOff && !showHolidays) {
      markResourceRequestAsComplete(
        mapToServiceRequest({
          ...requestParams,
          chartDateRange,
          showTimeOff: Boolean(showTimeOff),
          showHolidays: Boolean(showHolidays),
          cacheUpdateFunctions
        })
      );
    } else {
      markResourceRequestAsCompleteWithTimeoff(
        mapToServiceRequestWithTimeoff({
          ...requestParams,
          chartDateRange,
          showTimeOff,
          showHolidays,
          cacheUpdateFunctions
        })
      );
    }
  }, [
    cacheUpdateFunctions,
    chartDateRange,
    markResourceRequestAsComplete,
    markResourceRequestAsCompleteWithTimeoff,
    requestParams,
    showHolidays,
    showTimeOff
  ]);

  return {
    onMarkResourceRequestAsComplete,
    error:
      !showTimeOff && !showHolidays
        ? markAsCompleteError
        : markAsCompleteWithTimeoffError
  };
};

export default useMarkResourceRequestAsComplete;
